module.exports = __webpack_public_path__ + "img/1-1.dea72417.png";